import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterColumn'
})
export class FilterColumnPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    switch (value) {
      case 'fee':
        return '金額';
        break;
      case 'age':
        return '年齢';
        break;
      case 'number_of_connect_company':
        return '商深';
        break;
      case 'employment_status':
        return '雇用';
        break;
      case 'country_of_citizenship':
        return '国籍';
        break;
      case 'work_immidiately':
        return '開始';
        break;
      case 'interview_times':
        return '面談';
        break;
    }
  }
}
